import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useAuth } from '../../Context/AuthContext';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <Box 
      display="flex" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="100vh"
      bgcolor="background.default"
      position="relative"
    >
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate('/')}
        sx={{
          position: 'absolute',
          top: 20,
          left: 20,
          color: 'text.secondary',
          '&:hover': {
            color: 'primary.main',
            backgroundColor: 'action.hover'
          }
        }}
      >
        Back to Home
      </Button>

      <Box maxWidth={400} width="100%" p={3}>
        <Typography variant="h4" textAlign="left" mb={3} color="primary">
          TextWiz
        </Typography>
        <Typography variant="body1" textAlign="left" mb={3} color="textSecondary">
          Sign in to access your book library and AI features
        </Typography>
        <Authenticator
          loginMechanisms={['email']}
          signUpAttributes={['email']}
          formFields={{
            signUp: {
              email: {
                order: 1,
                required: true,
                placeholder: 'Enter your email',
              },
              password: {
                order: 2,
                required: true,
                placeholder: 'Create a password',
              },
              confirm_password: {
                order: 3,
                required: true,
                placeholder: 'Confirm your password',
              },
            },
            signIn: {
              username: {
                placeholder: 'Enter your email',
                label: 'Email',
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default LoginPage;

